import { useMemo } from 'react'
import useProductService from 'src/services/ProductService'
import useConsignmentService from 'src/services/ConsignmentService'
import useManufacturerService from 'src/services/ManufacturerService'
import useSiteService from 'src/services/SiteService'
import usePlatformService from 'src/services/PlatformService'

const useBreadcrumbNameResolvers = () => {
  const { getById: getProductById } = useProductService()
  const { getById: getConsignmentById } = useConsignmentService()
  const { getById: getManufacturerById } = useManufacturerService()
  const { getById: getSiteById } = useSiteService()
  const { getById: getPlatformById } = usePlatformService()

  return useMemo(
    () => ({
      product: async (id) => {
        const response = await getProductById(id)
        return response?.data?.productName ?? null
      },

      consignment: async (id) => {
        const response = await getConsignmentById(id)
        return response?.data?.referenceNumber ?? null
      },
      manufacturer: async (id) => {
        const response = await getManufacturerById(id)
        return response?.data?.manufacturerName ?? null
      },
      site: async (id) => {
        const response = await getSiteById(id)
        return response?.data?.siteName ?? null
      },
      platform: async (id) => {
        const response = await getPlatformById(id)
        return response?.data?.platformName ?? null
      },
    }),
    [getProductById, getConsignmentById, getManufacturerById, getSiteById, getPlatformById],
  )
}

export default useBreadcrumbNameResolvers
